import { Form } from 'react-bootstrap';

// Labeled field wrapper with inline error (small red text below the control).
export default function FormField({ label, required, error, children, hint }) {
  return (
    <Form.Group className="mb-3">
      {label && (
        <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
          {label} {required && <span style={{ color: '#dc2626' }}>*</span>}
        </Form.Label>
      )}
      {children}
      {hint && !error && <div className="hrms-muted" style={{ fontSize: '0.78rem', marginTop: 4 }}>{hint}</div>}
      {error && <div className="hrms-field-error">{error}</div>}
    </Form.Group>
  );
}
